import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-44fd63c5")
const _hoisted_1 = { class: "searchDiv" }
const _hoisted_2 = { class: "tableDiv" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" +新建模板 ")
const _hoisted_4 = { class: "templateDiv" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_7 = { class: "deleteTag" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "templateTitle" }
const _hoisted_11 = { class: "pagination" }
_popScopeId()

import { message } from 'ant-design-vue'
import { FormOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { reactive, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import SearchBar from '@/components/common/SearchBar'
import { getTeachPlanTemplateList, deleteTeachPlanTemplate } from '@/services/teach-plan-template'


export default {
  setup(__props) {

const router = useRouter()

const pageState = reactive({
  data: [],
  name: '',
  pagination: {
    current: 1,
    total: 1,
    pageSize: 12
  }
})

const handleCreate = () => {
  router.push('/resource/lesson-plan-template/edit/0')
}

const handleEdit = (templateItem) => {
  router.push(`/resource/lesson-plan-template/edit/${templateItem.id}`)
}

const handleDelete = async (templateItem) => {
  await deleteTeachPlanTemplate(templateItem.id)
  message.success('删除成功')
  getList({ page: pageState.pagination.current })
}

const getCurrentPageData = async (page) => {
  pageState.pagination.current_page = page
  await getList({ page: pageState.pagination.current })
}

const getList = async (params) => {
  params = { name: pageState.name, page: 1, per_page: pageState.pagination.pageSize, ...params }
  const { items, pagination } = await getTeachPlanTemplateList(params)
  pageState.data = items
  const { total, pageSize } = pagination
  pageState.pagination.total = total
  pageState.pagination.pageSize = pageSize
  console.log(pagination, items)
  console.log(pageState.data)
  console.log(pageState.data.content)
}

onBeforeMount(async () => {
  await getList()
})


return (_ctx, _cache) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_tabs = _resolveComponent("a-tabs")
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")
  const _component_a_pagination = _resolveComponent("a-pagination")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(SearchBar), {
        value: _unref(pageState).name,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => (_unref(pageState).name = $event)),
        "on-search": getList
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_tabs, { activeKey: "0" }, {
        tabBarExtraContent: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"flex":"1"},
            class: "btn",
            onClick: _cache[1] || (_cache[1] = $event => (handleCreate()))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, { tab: "教案模板" })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageState).data, (templateItem) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "template",
            key: templateItem.id
          }, [
            _createElementVNode("div", {
              class: "editTag",
              onClick: $event => (handleEdit(templateItem))
            }, [
              _createVNode(_unref(FormOutlined)),
              _hoisted_6
            ], 8, _hoisted_5),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_popconfirm, {
                placement: "bottom",
                title: "你确定要删除吗",
                "ok-text": "确定",
                "cancel-text": "取消",
                onConfirm: $event => (handleDelete(templateItem))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DeleteOutlined)),
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]),
            _createElementVNode("div", {
              class: "templatePreview",
              innerHTML: templateItem.content
            }, null, 8, _hoisted_9),
            _createElementVNode("p", _hoisted_10, _toDisplayString(templateItem.name), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_a_pagination, {
          current: _unref(pageState).pagination.current,
          "onUpdate:current": _cache[2] || (_cache[2] = $event => (_unref(pageState).pagination.current = $event)),
          "page-size": _unref(pageState).pagination.pageSize,
          "onUpdate:page-size": _cache[3] || (_cache[3] = $event => (_unref(pageState).pagination.pageSize = $event)),
          total: _unref(pageState).pagination.total,
          "show-total": total => `共 ${total} 条`,
          onChange: getCurrentPageData,
          "show-quick-jumper": ""
        }, null, 8, ["current", "page-size", "total", "show-total"])
      ])
    ])
  ], 64))
}
}

}